var _rect, _rect2, _path, _rect3, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPing({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 49,
    viewBox: "0 0 56 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 2.05238,
    width: 55.2986,
    height: 46.0631,
    rx: 5.14227,
    fill: "#34495E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 55.2986,
    height: 46.0631,
    rx: 5.14227,
    fill: "url(#paint0_linear_8394_18011)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1387 19.0152L21.7992 14.8935L14.1387 10.7718V7.5252L24.7423 13.2278L27.7068 14.8935L24.7423 16.5591L14.1387 22.2335V19.0152Z",
    fill: "#48576E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27.7051,
    y: 19.6111,
    width: 13.4541,
    height: 2.62241,
    fill: "#6ABA7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4872 32.7112H16.0147C16.2401 32.7112 16.4571 32.6945 16.6657 32.6611C16.8744 32.6277 17.0581 32.5651 17.2166 32.4733C17.3752 32.3731 17.5004 32.2354 17.5923 32.0601C17.6924 31.8848 17.7425 31.6553 17.7425 31.3715C17.7425 31.0877 17.6924 30.8581 17.5923 30.6829C17.5004 30.5076 17.3752 30.374 17.2166 30.2822C17.0581 30.182 16.8744 30.1153 16.6657 30.0819C16.4571 30.0485 16.2401 30.0318 16.0147 30.0318H14.4872V32.7112ZM12.5215 28.5043H16.5531C17.1123 28.5043 17.5881 28.5878 17.9804 28.7547C18.3727 28.9133 18.6899 29.1262 18.9319 29.3933C19.1824 29.6604 19.3618 29.965 19.4703 30.3072C19.5872 30.6495 19.6456 31.0042 19.6456 31.3715C19.6456 31.7304 19.5872 32.0852 19.4703 32.4357C19.3618 32.7779 19.1824 33.0826 18.9319 33.3497C18.6899 33.6168 18.3727 33.8338 17.9804 34.0008C17.5881 34.1594 17.1123 34.2387 16.5531 34.2387H14.4872V37.4439H12.5215V28.5043Z",
    fill: "#48576E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8725 28.5043H22.8382V37.4439H20.8725V28.5043Z",
    fill: "#48576E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5651 28.5043H26.5183L30.2493 34.5016H30.2744V28.5043H32.1149V37.4439H30.1492L26.4306 31.4591H26.4056V37.4439H24.5651V28.5043Z",
    fill: "#48576E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3059 36.4297C39.9553 36.8805 39.5672 37.1977 39.1415 37.3813C38.7158 37.5566 38.2859 37.6442 37.8519 37.6442C37.1674 37.6442 36.5498 37.5274 35.9989 37.2937C35.4563 37.0516 34.9972 36.7219 34.6216 36.3045C34.246 35.8872 33.958 35.3989 33.7577 34.8396C33.5574 34.2721 33.4572 33.6627 33.4572 33.0117C33.4572 32.3439 33.5574 31.7262 33.7577 31.1586C33.958 30.5827 34.246 30.0819 34.6216 29.6562C34.9972 29.2305 35.4563 28.8966 35.9989 28.6546C36.5498 28.4125 37.1674 28.2915 37.8519 28.2915C38.311 28.2915 38.7534 28.3624 39.1791 28.5043C39.6131 28.6379 40.0012 28.8382 40.3435 29.1053C40.694 29.3724 40.982 29.7021 41.2074 30.0944C41.4327 30.4867 41.5705 30.9374 41.6205 31.4466H39.7425C39.6256 30.9458 39.4002 30.5702 39.0664 30.3198C38.7325 30.0694 38.3277 29.9442 37.8519 29.9442C37.4095 29.9442 37.0339 30.0318 36.725 30.2071C36.4162 30.374 36.1658 30.6036 35.9738 30.8957C35.7818 31.1795 35.6399 31.505 35.5481 31.8723C35.4647 32.2396 35.4229 32.6194 35.4229 33.0117C35.4229 33.3873 35.4647 33.7545 35.5481 34.1135C35.6399 34.464 35.7818 34.7812 35.9738 35.065C36.1658 35.3488 36.4162 35.5784 36.725 35.7536C37.0339 35.9206 37.4095 36.004 37.8519 36.004C38.5029 36.004 39.0038 35.8413 39.3543 35.5157C39.7133 35.1819 39.9219 34.7019 39.9804 34.0759H38.0021V32.611H41.7583V37.4439H40.5062L40.3059 36.4297Z",
    fill: "#48576E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8394_18011",
    x1: 27.6493,
    y1: 0,
    x2: 27.6493,
    y2: 46.0631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEEBD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1FDF7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPing);
export default __webpack_public_path__ + "static/media/ping.79719b7eb350272649b35d3fd0d31324.svg";
export { ForwardRef as ReactComponent };